import React from "react";
import { useEffect, useState } from "react";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import { useAuthContext } from "./hooks/useAuthContext";
import { ToastContainer } from "react-toastify";

// Pages and Components
import Home from "./Home";
import BasicNavbar from "./Navbar";
import Login from "./Login";
import Stats from "./Stats.tsx";
import DarkModeToggle from "./DarkModeToggle";

//Styles
import './styles/darkmode.css';

function App() {
  const { user } = useAuthContext();
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'dark');

  const toggleTheme = () => {
    if (theme === 'dark') {
      setTheme('light');
    } else {
      setTheme('dark');
    }
  };

  useEffect(() => {
    localStorage.setItem('theme', theme);
    document.body.className = theme;
  }, [theme])


  return (
    <div className={`App ${theme}`}>
      <BrowserRouter>
        <BasicNavbar
          theme={theme}
          darkModeToggle={<DarkModeToggle theme={theme}
            toggleTheme={toggleTheme} />} />
        <Routes>
          <Route
            path="/"
            element={<Home theme={theme} />}
          ></Route>
          <Route
            path="/login"
            element={!user ? <Login theme={theme} /> : <Navigate to="/" />}
          ></Route>
          <Route
            path="/stats"
            element={user ? <Stats theme={theme} /> : <Login theme={theme} />}
          ></Route>
        </Routes>
      </BrowserRouter>
      <ToastContainer
        autoClose={3000}
        draggable
        theme={theme} />
    </div>
  );
}

export default App;